import { connect } from 'react-redux';
import { pauseMapUpdates, receivedMessageTrackerOnWS } from '../../redux/Actions/TrackerActions';

export default (WrappedComponent) => connect(null, {
  pauseMapUpdates,
  receivedMessageTrackerOnWS,
})(WrappedComponent);
